import { render, staticRenderFns } from "./PassportPagesModal.vue?vue&type=template&id=e637bbda&scoped=true&"
import script from "./PassportPagesModal.vue?vue&type=script&lang=js&"
export * from "./PassportPagesModal.vue?vue&type=script&lang=js&"
import style0 from "./PassportPagesModal.vue?vue&type=style&index=0&id=e637bbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e637bbda",
  null
  
)

export default component.exports